<template>
  <tr>
    <td>
      <wui-input-switch
        v-if="!isSaving"
        :model-value="item.enabled"
        small
        @update:model-value="onEnabledChange"
      />
      <div
        v-else
        class="w-9 flex justify-center"
      >
        <wui-icon
          class="text-primary"
          name="spinner"
        />
      </div>
    </td>
    <td>
      {{ item.name }}
    </td>
    <td>
      {{ item.number }}
    </td>
    <td>
      {{ groupTypeLabel }}
    </td>
  </tr>
</template>

<script setup lang="ts">
import { WuiIcon, WuiInputSwitch, useRenderNotifier } from '@wui/common-library'
import { computed } from 'vue'

import { QueueService, useQueueServiceStore } from '@/entities/queue-service'

import { useLocalization } from '@/shared/composables/localization'

const GROUP_TYPE_LOCALE_KEYS: Record<NonNullable<QueueService['groupType']>, string> = {
  regular: 'callsSettings.groupTypeRegular',
  overflow: 'callsSettings.groupTypeOverflow',
  timeout: 'callsSettings.groupTypeTimeout',
  transfer: 'callsSettings.groupTypeTransfer',
}

const props = defineProps<{
  item: QueueService
}>()

const store = useQueueServiceStore()
const { notifyError } = useRenderNotifier()
const { t } = useLocalization()

const isSaving = computed(() => store.isAgentSaving(props.item.agentGuid))

const groupTypeLabel = computed(() => {
  const { groupType } = props.item

  if (!groupType) {
    return '—'
  }

  return t(GROUP_TYPE_LOCALE_KEYS[groupType])
})

const onEnabledChange = async (enabled: boolean) => {
  try {
    await store.updateQueueEnabled(props.item.agentGuid, enabled)
  } catch (e) {
    notifyError(e instanceof Error ? e.message : String(e))
  }
}
</script>
